/* istanbul ignore file */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Checkbox from 'components/base/Checkbox';
import { REPOSITORIES_STATE } from 'common/constants/constants';
import { onRepositoryGitStreamIntegrationClick } from 'views/root/views/home/views/settings/views/RepositoriesV2/repositoriesSections';
import Tooltip from '@material-ui/core/Tooltip';
import { gitStreamCheckboxTooltips } from '../constants/gitStreamTooltips';
import { toggleModal } from 'state/callers';
import styled from 'styled-components';
import { isCmRepo } from './gitStream.service';

const StyledCheckbox = styled(Checkbox)`
  padding: 0;
`;
const getTooltipTitle = ({ isChecked, isCm }) =>
  isCm
    ? isChecked
      ? gitStreamCheckboxTooltips.CM_REPO_CHECKED
      : gitStreamCheckboxTooltips.CM_REPO_EMPTY
    : isChecked
    ? gitStreamCheckboxTooltips.SINGLE_REPO_CHECKED
    : gitStreamCheckboxTooltips.SINGLE_REPO_EMPTY;

const RepoGitStreamEnabledCheckbox = ({
  repository,
  updateRepository,
  getSensorAuthorizations,
  getRepositories,
  sensorAuthorizations
}) => {
  const dispatch = useDispatch();
  const { name: repoName, extra, state: repoState } = repository;
  const [isChecked, setIsChecked] = useState(extra.is_gitstream_enabled);
  const isCm = isCmRepo(repoName);
  const isDisabled = repoState !== REPOSITORIES_STATE.ACTIVE;
  return (
    <Tooltip
      disableHoverListener={isDisabled}
      title={getTooltipTitle({ isCm, isChecked })}
    >
      <div>
        <StyledCheckbox
          checked={isChecked}
          disabled={isDisabled}
          onChange={() =>
            onRepositoryGitStreamIntegrationClick({
              repository,
              updateRepository,
              getSensorAuthorizations,
              getRepositories,
              isChecked,
              setIsChecked,
              toggleModal: args => dispatch(toggleModal(args))
            })
          }
          color='primary'
          inputProps={{ 'aria-label': 'Select' }}
        />
      </div>
    </Tooltip>
  );
};

export default RepoGitStreamEnabledCheckbox;
